<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="head-user-modal-list">
            <h2>Deseja excluir a linha de cuidado?</h2>
         </div>
         
         <div class="body-user-modal-list">
             Ao fazer a exclusão, as unidades de saúde perderam os acessos a esta linha de cuidado e o procedimento é irreversível
         </div>
         <div class="footer-user-modal-list">
            <button mat-button class="btn-primary block" (click)="clickDelete()">
                <span *ngIf="isLoading == false">Sim, excluir</span>
                <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading == true"></mat-spinner>
            </button>
            <button mat-button class="btn-secundary block"(click)="clickCancel()">Cancelar</button>
        </div>
    </div>
</div>
